var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.667 12H4v1.333h8V2.667H4V4H2.667V2a.667.667 0 01.666-.667h9.334a.667.667 0 01.666.667v12a.666.666 0 01-.666.667H3.333A.666.666 0 012.667 14v-2zM4 7.333h4.667v1.334H4v2L.667 8 4 5.333v2z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/svg/logout-icon.svg";
export { SvgLogoutIcon as ReactComponent };